import { getGroup } from '@vlabs/api/artemy/client';
import { confirmAlert } from 'react-confirm-alert';

import { GroupAvailabilityConfirmation } from './GroupAvailabilityConfirmation';

export interface CheckGroupAvailabilityProps {
  groupId: string;
  onConfirm?: VoidFunction;
  onReject?: VoidFunction;
}

export type CheckGroupAvailabilityResult = 'confirmed' | 'cancelled';

export async function checkGroupAvailability({
  groupId,
  onConfirm = undefined,
  onReject = undefined,
}: CheckGroupAvailabilityProps): Promise<CheckGroupAvailabilityResult> {
  const artemyGroup = await getGroup(groupId);
  const permissionTag = artemyGroup.permission_tag;

  if (!permissionTag) {
    return 'confirmed';
  }

  return new Promise<CheckGroupAvailabilityResult>((resolve) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <GroupAvailabilityConfirmation
            groupName={artemyGroup.group_name}
            onConfirm={() => {
              onConfirm?.();
              resolve('confirmed');
              onClose();
            }}
            onReject={() => {
              onReject?.();
              resolve('cancelled');
              onClose();
            }}
            permissionTag={permissionTag}
          />
        );
      },
    });
  });
}
